<template>
  <div class="mt-8 w-full h-full">
    <Config />
  </div>
</template>

<script>
import Config from '../components/Configurations/Config.vue';

export default {
  name: 'Configurations',
  components: {
    Config,
  },
  mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    this.$store.dispatch('SettingsModule/Config/fetchMerchantConfig');
  },
};
</script>

<style scoped>

</style>
